import { useMediaQuery, useTheme } from "@mui/material";

const useMediaQueryHook = (value: string | number) => {
  const theme = useTheme();
  const matched = useMediaQuery(theme.breakpoints.down(value as never));
  return matched;
};

export default useMediaQueryHook;
